module.exports = __webpack_public_path__ + "media/images/edion/top/10-ad17c1b66d19485f32ed528f1569b5ec.png";